import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const BannerProduct = () => {
  return (
    <div className="BannerProduct">
      <div className="product1">
        <img
          src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"
          alt="Banner"
        />
        <div className="textBanner">
          <h1>ESSENTIAL AMIN.O. ENERGY</h1>
          <p>
            Ayuda a la recuperación de energía y muscular en cualquier momento.
          </p>
          <h2>100 MG DE CAFEÍNA</h2>
          <p>Ayuda con la concentración y la energía.</p>
          <h2>5 GRAMOS DE AMINOÁCIDOS</h2>
          <p style={{ marginBottom: "20px" }}>
            Apoya la recuperación muscular.
          </p>
          <Link className="toProduct" to="#">
            Ver producto
          </Link>
        </div>
      </div>
      <div className="product1">
        <img
          src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662085729/just/711zqkSe8oL._AC_SL1500_-removebg-preview_kgqq36.png"
          alt="Banner"
        />
        <div className="textBanner">
          <h1>ESSENTIAL AMIN.O. ENERGY</h1>
          <p>
            Ayuda a la recuperación de energía y muscular en cualquier momento.
          </p>
          <h2>100 MG DE CAFEÍNA</h2>
          <p>Ayuda con la concentración y la energía.</p>
          <h2>5 GRAMOS DE AMINOÁCIDOS</h2>
          <p style={{ marginBottom: "20px" }}>
            Apoya la recuperación muscular.
          </p>
          <Link className="toProduct" to="#">
            Ver producto
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BannerProduct;
